import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import api, { fmtDateTime } from "@/api";
import { useAuth } from "@/AuthContext";
import { Bell, CheckCheck } from "lucide-react";

export default function NotificationBell() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, []);
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const unread = items.filter((n) => !(n.read_by || []).includes(user?.id)).length;
  const markAll = async () => { await api.post("/notifications/read", { all: true }); load(); };

  return (
    <div className="relative" ref={ref}>
      <button data-testid="notification-bell" onClick={() => setOpen(!open)}
        className="relative w-9 h-9 rounded-full border bg-card hover:bg-accent transition-colors flex items-center justify-center text-muted-foreground">
        <Bell size={16} />
        {unread > 0 && (
          <span data-testid="notification-unread-count"
            className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-danger text-inverse text-[10px] font-bold flex items-center justify-center">
            {unread > 99 ? "99+" : unread}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-96 max-h-[70vh] overflow-y-auto rounded-xl border bg-popover shadow-xl z-50" data-testid="notification-panel">
          <div className="flex items-center justify-between px-4 py-3 border-b sticky top-0 bg-popover">
            <span className="font-heading font-semibold text-sm">Notifications</span>
            <button data-testid="mark-all-read-button" onClick={markAll} className="text-xs text-primary font-medium flex items-center gap-1 hover:underline">
              <CheckCheck size={13} /> Mark all read
            </button>
          </div>
          {items.slice(0, 40).map((n) => {
            const isUnread = !(n.read_by || []).includes(user?.id);
            return (
              <div key={n.id} className={`px-4 py-3 border-b last:border-0 text-sm ${isUnread ? "bg-primary" : ""}`}>
                <div className="flex gap-2">
                  <span className={`w-1.5 h-1.5 rounded-full mt-2 shrink-0 ${isUnread ? "bg-primary" : "bg-transparent"}`} />
                  <div className="min-w-0">
                    <div className="text-muted-foreground leading-snug">{n.message}</div>
                    <div className="text-[11px] text-muted-foreground/70 mt-1">{n.channel} · {fmtDateTime(n.created_at)}</div>
                  </div>
                </div>
              </div>
            );
          })}
          {!items.length && <div className="px-4 py-10 text-center text-sm text-muted-foreground">No notifications</div>}
          <Link to="/admin/notifications" onClick={() => setOpen(false)}
            className="block text-center text-xs text-primary font-medium py-2.5 border-t hover:bg-accent">View full audit trail</Link>
        </div>
      )}
    </div>
  );
}
